export var EventType;

(function (EventType) {
  EventType["OPERATIONAL"] = "operational";
  EventType["SCREEN"] = "screen";
  EventType["TRACK"] = "track";
  EventType["UI"] = "ui";
})(EventType || (EventType = {}));

export var ANALYTICS_CHANNEL = 'jql-editor';
export var Action;

(function (Action) {
  Action["CLICKED"] = "clicked";
  Action["RETRIEVE_FAILED"] = "retrieveFailed";
  Action["RETRIEVED"] = "retrieved";
  Action["SELECTED"] = "selected";
  Action["VIEWED"] = "viewed";
})(Action || (Action = {}));

export var ActionSubject;

(function (ActionSubject) {
  ActionSubject["BUTTON"] = "button";
  ActionSubject["AUTOCOMPLETE_OPTION"] = "autocompleteOption";
  ActionSubject["ERROR_MESSAGE"] = "errorMessage";
})(ActionSubject || (ActionSubject = {}));

export var ActionSubjectId;

(function (ActionSubjectId) {
  ActionSubjectId["EDITOR_EXPAND"] = "jqlEditorExpand";
  ActionSubjectId["EDITOR_SEARCH"] = "jqlEditorSearch";
  ActionSubjectId["EDITOR_HELP"] = "jqlEditorHelp";
  ActionSubjectId["JQL_RESULT"] = "jqlResult";
})(ActionSubjectId || (ActionSubjectId = {}));